import {
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import type { FC, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

export interface ReportTableColumn {
  readonly label: string;
  readonly align?: "left" | "right";
}

interface Props {
  readonly columns: ReportTableColumn[];
  readonly children: ReactNode;
}

const ReportTable: FC<Props> = ({ columns, children }) => (
  <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid rgba(0,0,0,0.08)", borderRadius: 2 }}>
    <Table size="small">
      <TableHead>
        <TableRow sx={{ bgcolor: "rgba(0,0,0,0.02)" }}>
          {columns.map((column) => (
            <TableCell key={column.label} align={column.align}>
              <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                {column.label}
              </Typography>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>{children}</TableBody>
    </Table>
  </TableContainer>
);

interface CustomerLinkProps {
  readonly customerId: string;
  readonly customerName: string;
}

/** Customer name opening the customer card in a new tab. */
export const CustomerLink: FC<CustomerLinkProps> = ({ customerId, customerName }) => (
  <Link
    component={RouterLink}
    to={`/customers/${customerId}`}
    target="_blank"
    variant="body2"
    underline="hover"
    sx={{ fontWeight: 500 }}
  >
    {customerName}
  </Link>
);

export default ReportTable;
